// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","posts":"Home_posts__RLiN7","search_form":"Home_search_form__1+mEg","noposts":"Home_noposts__0FU7t"};